import {
  SugarmateLogoIconAndTextDark,
  SugarmateLogoIconAndTextLight,
} from "@tandemdiabetes/sugarmate-react-components"
import { useDarkMode } from "src/contexts"

interface Props {
  className?: string;
}

export function Logo(props: Props) {
  const darkMode = useDarkMode()

  const LogoComponent = darkMode
    ? SugarmateLogoIconAndTextDark
    : SugarmateLogoIconAndTextLight

  return (
    <LogoComponent {...props} />
  )
}
